import { useWriteContract, useWaitForTransactionReceipt, usePublicClient } from 'wagmi'
import { BRIDGE_CONTRACT_ADDRESS, UNI2_CHAIN_ID } from '@/constants/addresses'
import { BRIDGE_ABI } from '@/constants/abis'

export function useCancelBridge() {
  const publicClient = usePublicClient({ chainId: UNI2_CHAIN_ID })

  const {
    data: hash,
    writeContractAsync,
    isPending: isWriting,
    error: writeError,
    reset,
  } = useWriteContract()

  const {
    isLoading: isConfirming,
    isSuccess,
    error: confirmError,
  } = useWaitForTransactionReceipt({
    hash,
  })

  const cancelBridge = async (lockId: bigint): Promise<`0x${string}`> => {
    // Envía la transacción y espera el hash
    const txHash = await writeContractAsync({
      address: BRIDGE_CONTRACT_ADDRESS,
      abi: BRIDGE_ABI,
      functionName: 'cancelLock',
      args: [lockId],
      chainId: UNI2_CHAIN_ID,
    })

    // Espera la confirmación de la transacción
    if (publicClient) {
      await publicClient.waitForTransactionReceipt({ hash: txHash })
    }

    return txHash
  }

  return {
    cancelBridge,
    hash,
    isWriting,
    isConfirming,
    isSuccess,
    isPending: isWriting || isConfirming,
    error: writeError || confirmError,
    reset,
  }
}
